const featuresConfiguration = {
  // stage: [alpha, beta, rc, rollout, stable]
  // rolloutSize: The percentage of users that should have access to a rollout. Defaults to 10.
  // rolloutOffset: What rolloutOrder to start the rolloutSize at, useful for assigning
  // different features to different groups. Defaults to 0.
  helm: {
    stage: 'alpha', // DO NOT CHANGE FROM ALPHA.
  },
  // 'gov-au-wa-2020-07': {
  //   stage: 'beta',
  // },
  courses: {
    stage: 'stable',
  },
  insurance: {
    stage: 'stable',
  },
  'deckee-shop': {
    stage: 'alpha',
  },
  'ramp-guidance': {
    stage: 'alpha',
  },
  'influencer-marker': {
    stage: 'beta',
  },
  'log-on-log-off': {
    stage: 'stable',
  },
  'force-log-on-log-off': {
    stage: 'alpha',
  },
  'device-orientation': {
    stage: 'alpha',
  },
  'data-capture-gyroscope': {
    stage: 'alpha',
  },
  'heatmaps-2.0': {
    stage: 'alpha',
    description: 'Heatmaps where we strip out roads and structures',
  },
  'trip-preview': {
    stage: 'stable',
    description: 'Preview a trip when looking at your logbook',
  },
  'trip-debug-active': {
    stage: 'alpha',
  },
  'insomnia-autolock': {
    stage: 'alpha',
  },
  'disable-high-accuracy': {
    stage: 'alpha',
  },
  'incident-reporting': {
    stage: 'stable',
  },
  'safety-recommendations': {
    stage: 'stable',
  },
  'marketplace-claim-profile': {
    stage: 'stable',
  },
  'friends-sheet': {
    stage: 'stable',
  },
  'deckee-signal': {
    stage: 'stable',
  },
  'instantaneous-speed-smoothing': {
    stage: 'alpha',
  },
  'activity-heatmaps': {
    stage: 'stable',
  },
  'on-the-water-detection': {
    stage: 'stable',
  },
  'subscription-features': {
    stage: 'stable',
  },
  'force-trigger-paywall': {
    stage: 'stable',
  },
  'mapbox-hover-pin': {
    stage: 'alpha',
  },
  'event-capture-debugging': {
    stage: 'alpha',
  },
  'enable-sqlite': {
    stage: 'stable',
  },
  'nsw-v2-atons': {
    stage: 'stable',
  },
  'vhf-radio-ranges': {
    stage: 'alpha',
  },
  // Old features for reference below
  // barCrossingMapMarkers: {
  //   stage: 'stable',
  // },
  // cMapLayer: {
  //   stage: 'beta',
  // },
  // letEmbarkMapLayer: {
  //   stage: 'beta',
  // },
  // userProfiles: {
  //   stage: 'stable',
  // },
  // sydneyHobartTracker: {
  //   stage: 'alpha',
  // },
  // windyWeather: {
  //   stage: 'alpha',
  // },
};

export default featuresConfiguration;
